import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import Modalizer from 'components/modalizer/modalizer'
import TeachModes from 'components/teach_modes/teach_modes'

import styles from './teach_lesson.scss'

import settingsIcon from 'assets/components/teach_modes/settings_icon.svg'

const TeachLessonModal = props => (
	<Modalizer closeAction={props.onCloseSelected}>
		<div styleName='container'>
			<div styleName='row'>
				<h2 styleName='title'>{localize('my_library_teach_modal_title')}</h2>
				<div styleName='settings' onClick={props.onSettingsSelected}>
					<Isvg src={settingsIcon} cacheGetRequests={true} styleName={'settings-icon'}/>
					{localize('my_library_teach_modal_settings')}
				</div>
			</div>
			<TeachModes
				canLaunchFrontOfTheClassroom={props.canLaunchFrontOfTheClassroom}
				canLaunchSession={props.canLaunchSession}
				canLaunchSessionWithZoom={props.canLaunchSessionWithZoom}
				canLaunchHomework={props.canLaunchHomework}
				launchFrontOfTheClassroom={props.launchFrontOfTheClassroom}
				launchLiveLesson={props.launchLiveLesson}
				launchHomework={props.launchHomework}
				launchLiveLessonWithZoom={props.launchLiveLessonWithZoom}
				hasActiveLiveCodes={props.hasActiveLiveCodes}
				hasActiveHomeworkCodes={props.hasActiveHomeworkCodes}
				onLiveActiveCodesSelected={props.onLiveActiveCodesSelected}
				onLiveWithZoomActiveCodesSelected={props.onLiveWithZoomActiveCodesSelected}
				onHomeworkActiveCodesSelected={props.onHomeworkActiveCodesSelected}
			/>
		</div>
	</Modalizer>
)

TeachLessonModal.propTypes = {
	onCloseSelected: PropTypes.func.isRequired,
	onSettingsSelected: PropTypes.func.isRequired,
	canLaunchFrontOfTheClassroom: PropTypes.bool,
	canLaunchSession: PropTypes.bool,
	canLaunchSessionWithZoom: PropTypes.bool,
	canLaunchHomework: PropTypes.bool,
	launchFrontOfTheClassroom: PropTypes.func,
	launchLiveLesson: PropTypes.func,
	launchHomework: PropTypes.func,
	launchLiveLessonWithZoom: PropTypes.func,
	hasActiveLiveCodes: PropTypes.bool,
	hasActiveHomeworkCodes: PropTypes.bool,
	onLiveActiveCodesSelected: PropTypes.func,
	onHomeworkActiveCodesSelected: PropTypes.func,
	onLiveWithZoomActiveCodesSelected: PropTypes.func,
}

TeachModes.defaultProps = {
	canLaunchFrontOfTheClassroom: false,
	canLaunchSession: false,
	canLaunchSessionWithZoom: false,
	canLaunchHomework: false,
	launchFrontOfTheClassroom: () => {},
	launchLiveLesson: () => {},
	launchHomework: () => {},
	launchLiveLessonWithZoom: () => {},
	hasActiveLiveCodes: false,
	hasActiveHomeworkCodes: false,
	onLiveActiveCodesSelected: () => {},
	onHomeworkActiveCodesSelected: () => {},
	onLiveWithZoomActiveCodesSelected: () => {},
}

export default CSSModules(TeachLessonModal, styles, {allowMultiple: true})
